import './ActionMenu.css';
import { NebulaButton as E, NebulaDropdown as S, NebulaDropdownItem as M, NebulaFavoritesButton as x } from "@discoveryedu/nebula-components";
import { resolveComponent as h, openBlock as s, createElementBlock as m, createBlock as u, createCommentVNode as c, createVNode as y, withCtx as p, Fragment as b } from "vue";
import { _ as D } from "./platform-components-assets/_plugin-vue_export-helper-es.js";
var g, L = new Uint8Array(16);
function N() {
  if (!g && (g = typeof crypto < "u" && crypto.getRandomValues && crypto.getRandomValues.bind(crypto) || typeof msCrypto < "u" && typeof msCrypto.getRandomValues == "function" && msCrypto.getRandomValues.bind(msCrypto), !g))
    throw new Error("crypto.getRandomValues() not supported. See https://github.com/uuidjs/uuid#getrandomvalues-not-supported");
  return g(L);
}
const _ = /^(?:[0-9a-f]{8}-[0-9a-f]{4}-[1-5][0-9a-f]{3}-[89ab][0-9a-f]{3}-[0-9a-f]{12}|00000000-0000-0000-0000-000000000000)$/i;
function F(e) {
  return typeof e == "string" && _.test(e);
}
var a = [];
for (var k = 0; k < 256; ++k)
  a.push((k + 256).toString(16).substr(1));
function R(e) {
  var t = arguments.length > 1 && arguments[1] !== void 0 ? arguments[1] : 0, i = (a[e[t + 0]] + a[e[t + 1]] + a[e[t + 2]] + a[e[t + 3]] + "-" + a[e[t + 4]] + a[e[t + 5]] + "-" + a[e[t + 6]] + a[e[t + 7]] + "-" + a[e[t + 8]] + a[e[t + 9]] + "-" + a[e[t + 10]] + a[e[t + 11]] + a[e[t + 12]] + a[e[t + 13]] + a[e[t + 14]] + a[e[t + 15]]).toLowerCase();
  if (!F(i))
    throw TypeError("Stringified UUID is invalid");
  return i;
}
function Q(e, t, i) {
  e = e || {};
  var r = e.random || (e.rng || N)();
  return r[6] = r[6] & 15 | 64, r[8] = r[8] & 63 | 128, R(r);
}
const v = "assign-cta-placement-experiment", B = {
  name: "ActionMenu",
  components: {
    NebulaButton: E,
    NebulaDropdown: S,
    NebulaDropdownItem: M,
    NebulaFavoritesButton: x
  },
  data() {
    var i, r;
    let e = !1, t = !1;
    if (typeof window < "u") {
      const l = ((r = (i = window.initData) == null ? void 0 : i.experiments) == null ? void 0 : r[v]) || {};
      e = !!l.is_member, t = l.is_member && !l.is_control;
    }
    return {
      actionMenuClass: "nebula-card__action-menu",
      isInAssignExperiment: e,
      prioritizeAssign: t
    };
  },
  props: {
    asset: {
      type: Object,
      required: !0
    },
    assetType: String,
    backUrl: String,
    quicklistIds: {
      type: Array,
      default() {
        return [];
      }
    },
    subscribedChannelIds: {
      type: Array,
      default() {
        return [];
      }
    },
    learnUrl: {
      type: String,
      default: "/learn"
    },
    userIsStudent: {
      type: Boolean,
      default: !1
    },
    showCreateWithStudio: {
      type: Boolean,
      default: !0
    },
    use2024HeartIcon: {
      type: Boolean,
      default: !0
    },
    favoritesTooltipPosition: {
      type: String,
      default: "block-start"
    }
  },
  emits: [
    "assign",
    "subscribe",
    "quicklist:add",
    "quicklist:remove",
    "save",
    "share",
    "studio:create",
    "unsubscribe"
  ],
  computed: {
    assetTypeFriendly() {
      return this.assetType ? this.assetType : this.asset.type && this.asset.type.name ? this.asset.type.name : this.asset.type_name ? this.asset.type_name : null;
    },
    assetSubtypeId() {
      var e, t, i, r;
      return this.asset.subtype_id || this.asset.sub_type_id || ((e = this.asset.subtype) == null ? void 0 : e.id) || ((t = this.asset.sub_type) == null ? void 0 : t.id) || ((i = this.asset.asset_subtype) == null ? void 0 : i.id) || ((r = this.asset.asset_sub_type) == null ? void 0 : r.id);
    },
    assetTypeId() {
      var e, t;
      return this.asset.type_id || ((e = this.asset.type) == null ? void 0 : e.id) || ((t = this.asset.asset_type) == null ? void 0 : t.id);
    },
    assignHref() {
      const e = this.asset.child_revision_id || this.asset.id, t = this.backUrl || window.location.href;
      return `${this.learnUrl}/assign/${e}?back=${encodeURIComponent(t)}`;
    },
    dropdownTriggerId() {
      return `action-menu--${Q()}`;
    },
    hasAssign() {
      return !this.showCreateWithStudio && this.isStudioAsset ? !1 : !this.isChannel && !this.isPage && !this.isInvestigation && !this.userIsStudent && this.classroomsEnabled;
    },
    myContentEnabled() {
      return window.initData && window.initData.product_settings ? window.initData.product_settings.ENABLEMYCONTENT : !0;
    },
    classroomsEnabled() {
      return window.initData && window.initData.product_settings ? window.initData.product_settings.CLASSROOMMANAGER : !0;
    },
    showQuickListOptions() {
      return this.assetTypeId === "a6d4de3c-8100-4fb5-b910-5cf311b51f1e" ? this.assetSubtypeId === "f7217318-a375-42be-bee7-1a991e045ef6" || this.assetSubtypeId === "9695ae47-bd47-4070-aa05-b8bdaa6ebcb0" : !0;
    },
    isChannel() {
      return this.assetTypeFriendly === "Channel";
    },
    isPage() {
      return this.assetTypeId === "b5bc40ea-f28b-4c3c-a8fb-34c600cd8d57";
    },
    isInvestigation() {
      return this.assetTypeId === "9c864e63-0018-452f-8cf6-e7bb8c204646";
    },
    isInQL() {
      return this.quicklistIds && this.quicklistIds.some((e) => e.toLowerCase() === (this.asset && this.asset.id.toLowerCase()));
    },
    isStudioAsset() {
      return this.assetSubtypeId === "f7217318-a375-42be-bee7-1a991e045ef6" || this.assetSubtypeId === "9695ae47-bd47-4070-aa05-b8bdaa6ebcb0" || [
        "854f468c-64b9-4bfb-9be2-32c9d5cc5243",
        // Board
        "9d23b45d-c8da-4fac-852a-c24d5cc4e348",
        // Slideshow
        "b424e481-30a1-482d-a2d7-ce9c3e5a50d7"
        // Lesson
      ].includes(this.assetTypeId);
    },
    isSubscribedChannel() {
      return this.subscribedChannelIds.find((e) => e.toLowerCase() === (this.asset && this.asset.id.toLowerCase()));
    },
    assetTitleOrName() {
      return this.asset.title || this.asset.name;
    },
    favoritesTracking() {
      return this.isInQL ? {
        "data-click-type": "Asset Action",
        "data-click-name": "Remove from Favorites"
      } : {
        "data-click-type": "Asset Action",
        "data-click-name": "Add to Favorites"
      };
    },
    channelTracking() {
      return this.isSubscribedChannel ? {
        "data-click-type": "Asset Action Menu",
        "data-click-name": "Remove from My Channels"
      } : {
        "data-click-type": "Asset Action Menu",
        "data-click-name": "Add to My Channels"
      };
    },
    studioTracking() {
      return {
        "data-click-type": "Asset Action Menu",
        "data-click-name": "Create with Studio"
      };
    },
    shareTracking() {
      return {
        "data-click-type": "Asset Action Menu",
        "data-click-name": "Share"
      };
    },
    myContentTracking() {
      return {
        "data-click-type": "Asset Action Menu",
        "data-click-name": "Save to My Content"
      };
    },
    assignTracking() {
      return {
        "data-click-type": "Asset Action Menu",
        "data-click-name": "Assign"
      };
    }
  },
  methods: {
    dropdownHandler(e, t) {
      !e && this.isInAssignExperiment && (window != null && window.DEAnalytics) && window.DEAnalytics.experiment(v), t();
    },
    unSubscribeToChannel(e) {
      this.$emit("unsubscribe", e), document.dispatchEvent(new CustomEvent("actionMenu", {
        detail: {
          type: "unsubscribe",
          asset: e
        }
      }));
    },
    subscribeToChannel(e) {
      this.$emit("subscribe", e), document.dispatchEvent(new CustomEvent("actionMenu", {
        detail: {
          type: "subscribe",
          asset: e
        }
      }));
    },
    removeFromQL(e) {
      this.$emit("quicklist:remove", e), document.dispatchEvent(new CustomEvent("actionMenu", {
        detail: {
          type: "quicklist:remove",
          asset: e
        }
      }));
    },
    addToQL(e) {
      this.$emit("quicklist:add", e), document.dispatchEvent(new CustomEvent("actionMenu", {
        detail: {
          type: "quicklist:add",
          asset: e
        }
      }));
    },
    createWithStudio(e) {
      this.$emit("studio:create", e), document.dispatchEvent(new CustomEvent("actionMenu", {
        detail: {
          type: "studio:create",
          asset: e
        }
      }));
    },
    share(e) {
      this.$emit("share", e), document.dispatchEvent(new CustomEvent("actionMenu", {
        detail: {
          type: "share",
          asset: e
        }
      }));
    },
    addToMyContent(e) {
      this.$emit("save", e), document.dispatchEvent(new CustomEvent("actionMenu", {
        detail: {
          type: "save",
          asset: e
        }
      }));
    },
    openDualAssignModal(e) {
      this.$emit("assign", { asset: e, assignHref: this.assignHref }), document.dispatchEvent(new CustomEvent("actionMenu", {
        detail: {
          type: "assign",
          asset: e,
          assignHref: this.assignHref
        }
      }));
    }
  }
}, H = { class: "action-menu" };
function q(e, t, i, r, l, n) {
  const w = h("NebulaFavoritesButton"), C = h("NebulaButton"), d = h("NebulaDropdownItem"), I = h("NebulaDropdown");
  return s(), m("div", H, [
    n.showQuickListOptions && i.use2024HeartIcon ? (s(), u(w, {
      key: 0,
      isFavorite: n.isInQL,
      tooltipPosition: i.favoritesTooltipPosition,
      onClick: t[0] || (t[0] = (o) => n.isInQL ? n.removeFromQL(i.asset) : n.addToQL(i.asset)),
      "tracking-data": n.favoritesTracking
    }, null, 8, ["isFavorite", "tooltipPosition", "tracking-data"])) : c("", !0),
    y(I, {
      buttonId: n.dropdownTriggerId,
      dropdownWrapperClass: l.actionMenuClass
    }, {
      trigger: p(({ toggleDropdown: o, checkArrowKeyOnTrigger: A, checkArrowKeyAfterTrigger: T, isOpen: f }) => [
        y(C, {
          iconLeft: "ellipses-vertical",
          id: n.dropdownTriggerId,
          shape: "pill",
          size: "s",
          type: "ghost",
          "aria-label": e.$t("Open actions menu"),
          onClick: (U) => n.dropdownHandler(f, o),
          onKeydown: A,
          onKeyup: T,
          "aria-expanded": f && "true" || "false"
        }, null, 8, ["id", "aria-label", "onClick", "onKeydown", "onKeyup", "aria-expanded"])
      ]),
      content: p(() => [
        l.prioritizeAssign ? (s(), m(b, { key: 0 }, [
          n.hasAssign ? (s(), u(d, {
            key: 0,
            link: n.assignHref,
            icon: "arrow-right-circle",
            text: e.$t("Assign"),
            "tracking-data": n.assignTracking
          }, null, 8, ["link", "text", "tracking-data"])) : c("", !0)
        ], 64)) : c("", !0),
        n.isChannel && !i.userIsStudent ? (s(), m(b, { key: 1 }, [
          n.isSubscribedChannel ? (s(), u(d, {
            key: 0,
            icon: "bookmark",
            text: e.$t("Remove from My Channels"),
            "tracking-data": n.channelTracking,
            onDropdownItemClicked: t[1] || (t[1] = (o) => n.unSubscribeToChannel(i.asset))
          }, null, 8, ["text", "tracking-data"])) : (s(), u(d, {
            key: 1,
            icon: "bookmark",
            text: e.$t("Add to My Channels"),
            "tracking-data": n.channelTracking,
            onDropdownItemClicked: t[2] || (t[2] = (o) => n.subscribeToChannel(i.asset))
          }, null, 8, ["text", "tracking-data"]))
        ], 64)) : c("", !0),
        n.showQuickListOptions && !i.use2024HeartIcon ? (s(), m(b, { key: 2 }, [
          n.isInQL ? (s(), u(d, {
            key: 0,
            icon: "heart--filled",
            text: e.$t("Remove from Favorites"),
            onDropdownItemClicked: t[3] || (t[3] = (o) => n.removeFromQL(i.asset)),
            "tracking-data": n.favoritesTracking
          }, null, 8, ["text", "tracking-data"])) : (s(), u(d, {
            key: 1,
            icon: "heart",
            text: e.$t("Add to Favorites"),
            onDropdownItemClicked: t[4] || (t[4] = (o) => n.addToQL(i.asset)),
            "tracking-data": n.favoritesTracking
          }, null, 8, ["text", "tracking-data"]))
        ], 64)) : c("", !0),
        i.showCreateWithStudio ? (s(), u(d, {
          key: 3,
          icon: "studio",
          text: e.$t("Create with Studio"),
          "tracking-data": n.studioTracking,
          onDropdownItemClicked: t[5] || (t[5] = (o) => n.createWithStudio(i.asset))
        }, null, 8, ["text", "tracking-data"])) : c("", !0),
        l.prioritizeAssign ? c("", !0) : (s(), m(b, { key: 4 }, [
          n.hasAssign ? (s(), u(d, {
            key: 0,
            link: n.assignHref,
            icon: "arrow-right-circle",
            text: e.$t("Assign"),
            "tracking-data": n.assignTracking
          }, null, 8, ["link", "text", "tracking-data"])) : c("", !0)
        ], 64)),
        y(d, {
          icon: "share",
          text: e.$t("Share"),
          "tracking-data": n.shareTracking,
          onDropdownItemClicked: t[6] || (t[6] = (o) => n.share(i.asset))
        }, null, 8, ["text", "tracking-data"]),
        n.myContentEnabled ? (s(), u(d, {
          key: 5,
          icon: "drive",
          text: e.$t("Save to My Content"),
          "tracking-data": n.myContentTracking,
          onDropdownItemClicked: t[7] || (t[7] = (o) => n.addToMyContent(i.asset))
        }, null, 8, ["text", "tracking-data"])) : c("", !0)
      ]),
      _: 1
    }, 8, ["buttonId", "dropdownWrapperClass"])
  ]);
}
const W = /* @__PURE__ */ D(B, [["render", q]]);
export {
  W as default
};
